import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Layout from "./Layout";
import { getApiUrl } from "./config";

function Accounts() {
  const role = localStorage.getItem("role") || "user";
  const isAdmin = role === "admin";
  const [accounts, setAccounts] = useState([]);
  const [newName, setNewName] = useState("");

  const fetchAccounts = useCallback(async () => {
    try {
      const res = await axios.get(`${getApiUrl()}/accounts`, { params: { type: "expense" } });
      setAccounts(res.data || []);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts]);

  const addAccount = async () => {
    const name = newName.trim();
    if (!name) return;
    try {
      await axios.post(`${getApiUrl()}/accounts`, { name, type: "expense" });
      setNewName("");
      fetchAccounts();
    } catch (err) {
      console.error(err);
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.sqlMessage ||
        err?.response?.data?.code ||
        "Failed to create account";
      alert(message);
    }
  };

  const toggleActive = async (acc) => {
    if (!isAdmin) return alert("Only admin can update records");
    try {
      await axios.put(`${getApiUrl()}/accounts/${acc.id}`, { active: !acc.active });
      fetchAccounts();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Layout>
      <div className="container mt-4">
        <h2>Accounts</h2>

        <div className="card p-4 mb-4">
          <h5>Expense Accounts</h5>
          <div className="row g-2 align-items-end">
            <div className="col-md-6">
              <label className="form-label">Account Name</label>
              <input
                className="form-control"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                onFocus={(e) => e.target.select()}
              />
            </div>
            <div className="col-md-3 d-grid">
              <button type="button" className="btn btn-primary" onClick={addAccount}>
                Add
              </button>
            </div>
          </div>
        </div>

        <div className="card p-4">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                  {isAdmin && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {accounts.map((a) => (
                  <tr key={a.id}>
                    <td>{a.name}</td>
                    <td>{a.active ? "Active" : "Inactive"}</td>
                    {isAdmin && (
                      <td>
                        <button
                          type="button"
                          className={`btn btn-sm ${a.active ? "btn-outline-danger" : "btn-outline-success"}`}
                          onClick={() => toggleActive(a)}
                        >
                          {a.active ? "Disable" : "Enable"}
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
                {accounts.length === 0 && (
                  <tr>
                    <td colSpan={isAdmin ? 3 : 2} className="text-center">
                      No accounts
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Accounts;
